module.exports = "<p>\r\n  entrega-factura works!\r\n</p>\r\n"